import alimsService from './http.service'
// 动态获取浏览器 url 中协议、ip、端口
var _origin = window.location.origin || (window.location.protocol + "//" + window.location.host);
var _model = window.location.host; // 动态部署，所有环境 只一个包
const registeAPI = {
  models:_model,
  storgaedate:"2021-06-17",
  hisignServerSocketParam:{
    "head":{
      "module":"HisignBrowserServerInterface",
      "function":"GetDeviceID",
      "clientid":"root",
      "userName":"10a979a50bd94923e7886a03870c451c",
      "serverurl": "",
      "args":"31b270600258c16d9109b9159e1c827eaa159f79a320534d022ce7537b77ab6c38596263558cb4fef03b729429b61985b32f8f12aed0af691268168f4d82b969",
      "whitelist":""
    },
    "body":""
  },
  getChatRecordSocketParams(){
    return {
     [_model]:{
       "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
       "type": "",// QQ：1030031，微信：1030036
       "realm": "China",
       "client": "gnt_hiso",
       "username": "939070",
       "password": "123456",
       "clientSecret": "fb8fbdb9-bf09-4037-9d98-642621359db8",
       "refreshToken": "fb8fbdb9-bf09-4037-9d98-642621359db8",
       "attributes": {},
       "tokenServerUrl": "https://sso.higovnet.net.cn/uc_api/token",
       "UploadURL": "http://192.168.11.43:58080",
     },
      "123.57.1.59":{
        "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
        "type": "",// QQ：1030031，微信：1030036
        "realm": "China",
        "client": "gnt_hiso",
        "username": "939070",
        "password": "123456",
        "clientSecret": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "refreshToken": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "attributes": {},
        "tokenServerUrl": "https://sso.higovnet.net.cn/uc_api/token",
        "UploadURL": "http://192.168.11.43:58080",
      },
     "192.168.129.207":{
       "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
       "type": "",// QQ：1030031，微信：1030036
       "realm": "China",
       "client": "gnt_hiso",
       "username": "939070",
       "password": "123456",
       "clientSecret": "fb8fbdb9-bf09-4037-9d98-642621359db8",
       "refreshToken": "fb8fbdb9-bf09-4037-9d98-642621359db8",
       "attributes": {},
       "tokenServerUrl": "https://sso.higovnet.net.cn/uc_api/token",
       "UploadURL": "http://192.168.11.43:58080",
     },
      "192.168.129.201":{
        "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
        "type": "",// QQ：1030031，微信：1030036
        "realm": "China",
        "client": "gnt_hiso",
        "username": "939070",
        "password": "123456",
        "clientSecret": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "refreshToken": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "attributes": {},
        "tokenServerUrl": "https://sso.higovnet.net.cn/uc_api/token",
        "UploadURL": "http://192.168.129.203:58080",
      },
     "fanzhalianmeng.com":{
       "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
       "type": "",// QQ：1030031，微信：1030036
       "realm": "China",
       "client": "gnt_hiso",
       "username": "939070",
       "password": "123456",
       "clientSecret": "fb8fbdb9-bf09-4037-9d98-642621359db8",
       "refreshToken": "fb8fbdb9-bf09-4037-9d98-642621359db8",
       "attributes": {},
       "tokenServerUrl": "https://sso.higovnet.net.cn/uc_api/token",
       "UploadURL": "http://192.168.11.43:58080",
     },
     "old.fanzhalianmeng.com":{
        "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
        "type": "",// QQ：1030031，微信：1030036
        "realm": "China",
        "client": "gnt_hiso",
        "username": "939070",
        "password": "123456",
        "clientSecret": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "refreshToken": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "attributes": {},
        "tokenServerUrl": "https://sso.higovnet.net.cn/uc_api/token",
        "UploadURL": "http://192.168.11.43:58080",
      }
   }
  },
  /*getGNTToken(){
    return {
      "dev":{
        "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
        "type": "",// QQ：1030031，微信：1030036
        "realm": "China",
        "client": "gnt_hiso",
        "username": "15010151725",
        "password": "123456",
        "clientSecret": "32a480bb-b3d1-45ee-83fb-31b051cae2ff",
        "refreshToken": "32a480bb-b3d1-45ee-83fb-31b051cae2ff",
        "attributes": {},
        "tokenServerUrl": "http://www.higovnet.net:7002/usercenter/token",
        "UploadURL": "http://192.168.11.43:58080",
      },
      "prod":{
        "uuid": "79abe18e-b47c-42a4-8725-19f426aab49c",
        "type": "",// QQ：1030031，微信：1030036
        "realm": "China",
        "client": "gnt_hiso",
        "username": "15010151725",
        "password": "123456",
        "clientSecret": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "refreshToken": "fb8fbdb9-bf09-4037-9d98-642621359db8",
        "attributes": {},
        "tokenServerUrl": "https://sso.higovnet.net.cn/uc_api/token",
        "UploadURL": "http://192.168.11.43:58080",
      }
    }
  },*/
  ///////////////////////////////////////////////////
  /*downLoadUrl(){ // 目前不用了!!!!!
    return {
      "dev":{
        "url":"192.168.40.214:8081/apmAPI/socket/appDownload/"
      },
      "prod":{
        "url":"https://192.168.40.207:8081/apmAPI/zjFile/"
      }
    }
  },*/
  ///////////////////////////////////////////////////
  /*idCardAddress(){
    return {
      "dev":{
        "url":"https://192.168.40.214:8081/apmAPI/scanIDCard"
      },
      "prod":{
        "url":"https://192.168.10.204:8081/apmAPI/scanIDCard"
      }
    }
  },*/
  appDownLoad(){
    return {
      [_model]:{
        "url": `https://${_model}/static/apk/appcollect.apk`
      },
      "192.168.40.247:8088":{
        "url":"https://211.157.146.9:9090/static/apk/appcollect.apk"
      },
      "192.168.129.207":{
        "url":"https://192.168.129.207/static/apk/appcollect.apk"
      },
      "192.168.129.201":{
        "url":"https://192.168.129.201/static/apk/appcollect.apk"
      },
      "123.57.1.59":{
        "url":"https://123.57.1.59/static/apk/appcollect.apk"
      },
      "fanzhalianmeng.com":{
        "url":"https://fanzhalianmeng.com/static/apk/appcollect.apk" // 生成域名
        //"url":"https://218.61.5.206/static/apk/appcollect.apk" // 生成ip
      },
      "old.fanzhalianmeng.com":{
        "url":"https://old.fanzhalianmeng.com/static/apk/appcollect.apk" // 生成域名
        //"url":"https://218.61.5.206/static/apk/appcollect.apk" // 生成ip
      }
    }
  },
  // 海鑫集成服务下载地址
  hisignBrowserServerDownLoad(){
    return {
      [_model]:{
        "url": `https://${_model}/hisignServer/`
        // "url": _origin + "/static/hisignServer/"
        // "url":"https://211.157.146.9:9090/static/hisignServer/"
      },
      "192.168.129.207":{
        "url": "https://192.168.129.207/hisignServer/"
      },
      "192.168.129.201":{
        "url": "https://192.168.129.201/hisignServer/"
      },
      "123.57.1.59":{
        "url": "https://123.57.1.59/hisignServer/"
      },
      "fanzhalianmeng.com":{
        "url":"https://fanzhalianmeng.com/hisignServer/" // 生成域名
        //"url":"https://218.61.5.206/static/hisignServer/" // 生成ip
      },
      "old.fanzhalianmeng.com":{
        "url":"https://old.fanzhalianmeng.com/hisignServer/" // 生成域名
        //"url":"https://218.61.5.206/static/hisignServer/" // 生成ip
      }
    }
  },
  // 海鑫集成服务下载存入本地路径
  /*hisignBrowserServeLocalpath(){
    return {
      "dev":{
        "url":"c:\\\\"
      },
      "prod":{
        "url":"c:\\\\"
      }
    }
  },*/
  // 海鑫集成服务下载存入本地文件名
  /*hisignBrowserServeLocalFilename(){
    return {
      "dev":{
        "url":"HisignCollectUpdateZip.zip"
      },
      "prod":{
        "url":"HisignCollectUpdateZip.zip"
      }
    }
  },*/
  uploadUrl(){
    return {
      [_model]: {
        "url": "http://123.57.1.59:58080"
      },
      "192.168.40.247:8088": {
        "url": "https://192.168.43.221:58080"
      },
      "192.168.129.201":{
        "url":"http://192.168.129.203:58080"
      },
      "fanzhalianmeng.com": {
        "url": "http://123.57.1.59:58080"
      },
    }
  },
  apmAPIUrl(){
    return {
      [_model]:{
        "url":`https://${_model}`
      },
      "192.168.40.247:8088":{
        "url":"https://192.168.40.214:8081"
      },
      "192.168.43.221":{
        "url":"https://192.168.40.214:8081"
      },
      "192.168.129.207":{
        "url":"https://192.168.129.207:443"
      },
      "192.168.129.201":{
        "url":"https://192.168.129.201:443"
      },
      "123.57.1.59":{
        "url":"https://123.57.1.59"
      },
      "fanzhalianmeng.com":{
        "url":"https://fanzhalianmeng.com"
        //"url":"https://218.61.5.206"
      },
      "old.fanzhalianmeng.com":{
        "url":"https://old.fanzhalianmeng.com"
        //"url":"https://218.61.5.206"
      }
    }
  },
  hisignService(){ // 海鑫服务验证请求
    let _obj = {
      [_model]:{
        "url":"bea773094760e6aa1eb01eff56f768fa31b8288de89a1f67d97fe428e6d364de37117849559fd373eb0dee13e6a032a8" // 测试环境（内网）
        // 1dba58f4eb8404468ce8d0cf3666b15bd22e4c8810a1c7e1f8387d85b3cf9906c90075acce79b15936fcfb5c5015311d  外网映射
        // bea773094760e6aa1eb01eff56f768fa4836598206d780bcc9a8e1009ca5381826a3c2c4c504d246c5a614217a61d447 开发环境
        // bea773094760e6aa1eb01eff56f768fa7715cd45d5b63572532425c904552cd537117849559fd373eb0dee13e6a032a8 开发环境 new
      },
      "192.168.129.207":{
        "url":"bea773094760e6aa1eb01eff56f768fa31b8288de89a1f67d97fe428e6d364de37117849559fd373eb0dee13e6a032a8" // 测试环境
      },
      "192.168.129.201":{
        "url":"bea773094760e6aa1eb01eff56f768fa4bcbec50f552ccddead80e10d8bc5fd437117849559fd373eb0dee13e6a032a8" // 测试环境
      },
      "123.57.1.59":{
        "url":"1dba58f4eb8404468ce8d0cf3666b15bd22e4c8810a1c7e1f8387d85b3cf9906c90075acce79b15936fcfb5c5015311d" // 测试环境
      },
      "fanzhalianmeng.com":{
        "url":"76a40d185d5202f0279d327005f7800506507fcf5c5c8524a069c4c2642c121dc90075acce79b15936fcfb5c5015311d" // 生产环境域名
        //"url":"6b961c4f3606fc1e70889fe0eb8b87aa281f858c7a36c51dbd0888e467255a418ecb7632ac3ecc2b2c6f267ddd1e9d84" // 生产ip
      },
      "fanzhalianmeng.hisign.com.cn":{
        "url":"76a40d185d5202f0279d327005f78005198015b9f5e51166db297d5c2825e55ef45e72033a139f0b155c600d4a35956e8ecb7632ac3ecc2b2c6f267ddd1e9d84" // 生产环境域名 https://fanzhalianmeng.hisign.com.cn/apmAPI/scanIDCard
      },
      "old.fanzhalianmeng.com":{
        "url":"bf4c831eafabb82e687cae5028fa10d436546ed4765597cf77ebe2027c75aeb763b4152a1711871e25a225e820a78f25149dfd07a55615208644039a523c276f" // 生产环境域名
        //"url":"6b961c4f3606fc1e70889fe0eb8b87aa281f858c7a36c51dbd0888e467255a418ecb7632ac3ecc2b2c6f267ddd1e9d84" // 生产ip
      }
    }
    return _obj
  },
  getCodeUrl(){ // 验证码地址
    return {
      [_model]:{
        "url":`https://${_model}/apmAPI/getCode` // 生产环境域名
      },
      "192.168.40.247:8088":{
        "url":"https://192.168.129.207:443/apmAPI/getCode"
      },
      "192.168.129.207":{
        "url":"https://192.168.129.207:443/apmAPI/getCode"
      },
      "192.168.129.201":{
        "url":"https://192.168.129.201:443/apmAPI/getCode"
      },
      "123.57.1.59":{
        "url":"https://123.57.1.59/apmAPI/getCode"
      },
      "fanzhalianmeng.com":{
        "url":"https://fanzhalianmeng.com/apmAPI/getCode" // 生产环境域名
        //"url":"https://218.61.5.206/apmAPI/getCode" // 生产ip
      },
      "old.fanzhalianmeng.com":{
        "url":"https://old.fanzhalianmeng.com/apmAPI/getCode" // 生产环境域名
        //"url":"https://218.61.5.206/apmAPI/getCode" // 生产ip
      }
    }
  },
  getPresignedUrl(params) { // 获取签名地址
    return alimsService.post('/fdfs/api/file/getPresignedUrl', params);
  },
  login(params) { // 登录
    return alimsService.post('/apmAPI/login', params);
  },
  loadCommonQuestList(){ // 读取基础问题
    return alimsService.get('/apmAPI/question/base', null);
  },
  loadCodeMap(){ // 获取码表信息
    return alimsService.get('/apmAPI/sysDict/queryBaseDict', null);
  },
  loadCodeMapForAJLB(){
    return alimsService.get('/apmAPI/sysDict/queryCaseFlag', null);
  },
  getBaseConfig(){ // 获取系统基本配置
    return alimsService.get('/apmAPI/sysConfig/baseConfig', null);
  },
  queryBaseConfig(){ // 获取系统基本配置(包括授权码)
    return alimsService.get('/apmAPI/sysConfig/query', null);
  },
  updateCaseOperator(params){//案件操作人记录人保存
    return alimsService.post('/apmAPI/caseInfo/saveOrUpdateCaseOperator', params);
  },
  reportPersonSave(params){ // 受害人信息保存
    return alimsService.post('/apmAPI/reportPerson/save', params);
  },
  reportPersonUpdate(params){ // 受害人信息更新
    return alimsService.post('/apmAPI/reportPerson/update', params);
  },
  caseInfoUpdate(params) { //案件信息更新
    return alimsService.post('/apmAPI/caseInfo/update', params);
  },
  caseInfoCheck(params) { //案件信息确认
    return alimsService.post('/apmAPI/caseInfo/caseCheck', params);
  },
  getNextQuestion(params){ // 获取下一问题描述
    return alimsService.get('/apmAPI/question/next', params);
  },
  saveOrUpdateCriminalInfo(params){ // 嫌疑人身份保存
    return alimsService.post('/apmAPI/criminalInfo/saveOrUpdate', params);
  },
  savePhoneInfo(params){ // 保存受害人手机信息
    return alimsService.post('/apmAPI/evidence/savePhoneInfo', params);
  },
  baseQuestionConfig(){ // 获取问题大类显示配置
    return alimsService.get('/apmAPI/sysDict/baseQuestionConfig', null);
  },
  saveBaseinfoEvidence(params){//证据基本信息保存
    params.noSpin = true;
    return alimsService.post('/apmAPI/evidence/saveBaseinfo', params);
  },
  uploadImg(params){ // 上传图片
    return alimsService.post('/apmAPI/evidence/uplodZjFile', params);
  },
  downLoadImg(params){ // 图片预览
    return alimsService.get('/apmAPI/evidence/getZjFile', params);
  },
  uploadRecord(params){ // 上传笔录
    return alimsService.post('/apmAPI/reportPerson/saveBlImg', params);
  },
  creatRelation(params){ // 创建关联关系
    params.noSpin = true;
    return alimsService.post('/apmAPI/evidence/saveZjRelation', params);
  },
  sysVersion(params){
    return alimsService.get('/apmAPI/sysVersion', null);
    // return alimsService.get('/apmAPI/sysDeviceInfo/softVersion', params);
  },
  checkSoftVersion(params){ // 查询最新版本和是否升级
    params.noSpin = true;
    return alimsService.post('/apmAPI/checkSoftVersion', params);
  },
  updateDeviceSoftVersion(params){ // 修改服务版本号
    params.noSpin = true;
    return alimsService.post('/apmAPI/updateDeviceSoftVersion', params);
  },
  updateServerVersion(params){
    return alimsService.post('/apmAPI/sysDeviceInfo/updateSoftVersion', params);
  },
  /*ssoSettings(){
    return alimsService.post('/sso/api/sys/settings', {});
  },*/
  /*ssoLogin(params){
    return alimsService.post('/sso/api/sys/login/login', params);
  },*/
  checkAuthorization(params){ // 授权码登录
    return alimsService.post('/apmAPI/checkAuthorization', params);
  },
  evidenceSearch(params){ // 取证查询
    return alimsService.get('/apmAPI/reportPerson/findByPage', params);
  },
  evidenceExport(params){ // 取证导出
    return alimsService.get('/apmAPI/reportPerson/export', params);
  },
  reSendEvidence(params){ // 再次推送
    return alimsService.get('/apmAPI/caseInfo/reportCase', params);
  },
  queryRecordByPId(params){
    return alimsService.post('/apmAPI/reportPerson/queryById', params);
  },
  queryEvidenceList(params){
    return alimsService.get('/apmAPI/reportPerson/queryAllEvidence', params);
  },
  downloadProgress(params){
    return alimsService.get('/apmAPI/evidence/asyncDownload', params);
  },
  queryQuestionConfig(params){
    return alimsService.get('/apmAPI/questionConfig/queryQuestionConfig', params);
  },
  updatequeryQuestionConfig(params){
    params.noSpin = true;
    return alimsService.post('/apmAPI/questionConfig/update', params);
  },
  updateBaseConfig(params){ // 更新系统基本配置
    params.noSpin = true;
    return alimsService.post('/apmAPI/sysConfig/update', params);
  },
  getQuestionById(id){
    return alimsService.get('/apmAPI/question/' + id, null);
  },
  // QQ、微信聊天记录取证 相关 START
  // 聊天记录保存
  saveChatRecord(params){
    return alimsService.post('/apmAPI/elecEvidence/save', params);
  },
  // 聊天记录打包
  asyncZipFile(params){
    return alimsService.post('/apmAPI/elecEvidence/asyncZipFile', params);
  },
  // 聊天记录中根据md5查询附件
  queryMD5FilePath(params){
    return alimsService.get('/apmAPI/elecEvidence/queryMD5FilePath', params);
  },
  // 查询电子取证
  getByPrimaryKey(params){
    return alimsService.get('/apmAPI/elecEvidence/getByPrimaryKey', params);
  },
  // QQ、微信聊天记录取证 相关 END
  httpCaptureSave(params){ //抓包保存
    return alimsService.post('/apmAPI/elecEvidence/httpCaptureSave', params);
  },
  queryZjApp(caseId){// 根据CASEID进行查询APP列表
    return alimsService.get('/apmAPI/elecEvidence/queryZjApp?caseId=' + caseId, {"noSpin":true});
  },
  // 根据caseId 查询安卓程序上传的APP相关信息
  selectZjApps(params){
    return alimsService.get('/apmAPI/elecEvidence/selectZjApps', params);
  },
  // 根据caseId 获取证据聊天记录压缩包
  selectZjChatFiles(params){
    return alimsService.get('/apmAPI/elecEvidence/selectZjChatFile', params);
  },
  // 根据caseId 获取证据聊天语音压缩包
  selectZjAudioFiles(params){
    return alimsService.get('/apmAPI/elecEvidence/selectZjAudioFile', params);
  },
  // 根据authCode 删除取证记录
  deleteByPrimaryKeyAndBatchNo(params){
    return alimsService.get('/apmAPI/elecEvidence/deleteByPrimaryKeyAndBatchNo', params);
  },
  // 取证聊天回滚
  rollbackByBatchNo(params){
    return alimsService.get('/apmAPI/elecEvidence/rollbackByBatchNo', params);
  },

  queryDevice(deviceNumber){ //获取设备信息
    return alimsService.get('/apmAPI/sysDeviceInfo/query?deviceNumber=' + encodeURIComponent(deviceNumber), {noSpin: true});
  },
  saveDevice(params){ //保存设备信息
    params.noSpin = true;
    return alimsService.post('/apmAPI/sysDeviceInfo/save', params);
  },
  updateDevice(params){ //保存设备信息
    params.noSpin = true;
    return alimsService.post('/apmAPI/sysDeviceInfo/update', params);
  },

  // 静态分析
  analyseApk (params){ // 发起分析
    params.noSpin = true;
    return alimsService.post('/apmAnalyse/apk/analyseApk', params);
  },
  getFolderTree(params){ // 获取目录树
    params.noSpin = true;
    return alimsService.post('/apmAnalyse/apk/getFolderTree', params);
  },
  getFileText(params){
    return alimsService.post('/apmAnalyse/apk/getFileText', params);
  },
  // 图表数量查询
  countAppAndCase(params){
    return alimsService.get('/apmAnalyse/apk/countAppAndCase', params);
  },
  // APK列表信息查询
  countApp(params){
    return alimsService.get('/apmAnalyse/apk/countApp', params);
  },
  // APK关联案件信息查询
  queryPackageNameOperInfo(params){
    return alimsService.get('/apmAnalyse/apk/queryPackageNameOperInfo', params);
  },
  // APK关联案件信息查询
  getApkList(params){
    return alimsService.get('/apmAnalyse/apk/getApkList', params);
  },
  // APK详情信息查询
  getAppInfo(params){
    return alimsService.get('/apmAnalyse/apk/getAppInfo', params);
  },
  // APK详情信息查询（APK统计下载）
  getAppDownloadInfo(params){
    return alimsService.get('/apmAnalyse/apk/getAppDownloadInfo', params);
  },
  // 查询APP线索查询
  queryAppClue(params){
    return alimsService.get('/apmAnalyse/apk/queryAppClue', params);
  },
  // 查询APP线索更新
  updateAppClue(params){
    return alimsService.post('/apmAnalyse/apk/updateAppClue', params);
  },
  addTag(tag){
    return alimsService.get('/apmAnalyse/searchTag/addTag?tag=' + tag, {});
  },
  getCountTag(params){
    return alimsService.post('/apmAnalyse/searchTag/getCountTag', params);
  },
  getDelAnalyseFiles(params){
    return alimsService.post('/apmAnalyse/delAnalyseFiles', params);
  },

  getIP(params){  // 更具网址域名获取ip
    return alimsService.get('/apmAPI/sysUtils/getIP', params);
  },
  bankCardBin(params){  //匹配开户行
    return alimsService.get('/apmAPI/sysUtils/bankCardBin?accountNo=' + params, {noSpin: true});
  },
  queryAudioZjBaseInfo(caseId, phone){ //获取通话录音
    return alimsService.get('/apmAPI/elecEvidence/queryAudioZjBaseInfo?caseId=' + caseId + '&phone='+ encodeURIComponent(phone), {noSpin: true});
  },
  queryVideoZjBaseInfo(caseId, account){ //获取通话录音
    return alimsService.get('/apmAPI/elecEvidence/queryVideoZjInfo?caseId=' + caseId + '&account='+ account);
  },
  deleteAudioZjBaseInfo(jlid){ //删除通话录音
    return alimsService.get('/apmAPI/elecEvidence/deleteAudioZjBaseInfo?id=' + jlid, {noSpin: true});
  },
  insertOrUpdateAjCache(params){
    return alimsService.post('/apmAPI/ajCache/insertOrUpdateAjCache', params);
  },
  sysInquiryRecordInsert(params){
    return alimsService.post('/apmAPI/sysInquiryRecord/insert', params);
  },
  sysInquiryRecordUpdate(params){
    return alimsService.post('/apmAPI/sysInquiryRecord/update', params);
  },
  sysInquiryRecordQueryByUsername(username){
    return alimsService.get('/apmAPI/sysInquiryRecord/queryByUsername?username=' + encodeURIComponent(username), {noSpin: true});
  },
  sysInquiryRecordDelete(id){
    return alimsService.get('/apmAPI/sysInquiryRecord/delete?id=' + id, {noSpin: true});
  },
  ajCacheQueryAjCache(id){
    return alimsService.get('/apmAPI/ajCache/queryAjCache?caseId=' + id, {noSpin: true});
  },
  getReportBlFiles(id){
    return alimsService.get('/apmAPI/reportPerson/getReportBlFiles?caseId=' + id, {noSpin: true});
  },
  reportPersonGetReportBlFilePath(id){
    return alimsService.get('/apmAPI/reportPerson/getReportBlFilePath?caseId=' + id, {noSpin: true});
  },
  reportPersonGetReportKYFilePath(id){ // 下载现勘笔录
    return alimsService.get('/apmAPI/reportPerson/getReportKYFilePath?caseId=' + id, {noSpin: true});
  },
  reportPersonGetReportXWFilePath(id){ // 下载现勘笔录
    return alimsService.get('/apmAPI/reportPerson/getReportXWFilePath?caseId=' + id, {noSpin: true});
  },

  reportPersonGetReportSZFilePath(id){
    return alimsService.get('/apmAPI/reportPerson/getReportSZFilePath?caseId=' + id, {noSpin: true});
  },



  reportPersonSaveZzxwblFilePath(params){ // 上传笔录
    return alimsService.post('/apmAPI/reportPerson/saveZzxwblFilePath', params);
  },
  reportPersonQueryZzxwbl(params){ // 查询笔录
    return alimsService.get('/apmAPI/reportPerson/queryZzxwbl', params);
  },
  reportPersonDeleteZzxwbl(params){ // 删除笔录
    return alimsService.get('/apmAPI/reportPerson/deleteZzxwbl', params);
  },
  transferdataSave(params){ // 上传笔录
    return alimsService.post('/apmAPI/transferdata/save', params);
  },
  updateHandleStatus(params){
    return alimsService.post('/apmAPI/transferdata/updateHandleStatus', params);
  },
  transferdataQuery(id){
    return alimsService.get('/apmAPI/transferdata/query?id=' + id);
  },

  evidenceDeletePhoneInfo(id){
    return alimsService.get('/apmAPI/evidence/deletePhoneInfo?phoneId=' + id, {noSpin: true});
  },
  evidencePhoneContactRecord(params){ // 获取手机采集手机通话信息列表
    return alimsService.get('/apmAPI/evidence/phoneContactRecord?caseId=' + params.caseID + "&phoneNo=" + encodeURIComponent(params.phoneNo) + "&smallType=" + params.smallType + "&pageNum=" + params.pageNum + "&pageSize=" + params.pageSize, {noSpin: true});
  },
  queryHandleStatus(id){ // 二维码进度
    return alimsService.get('/apmAPI/transferdata/queryHandleStatus?id=' + id, {noSpin: true});
  },
  deletePhoneContactRecord(params){ // 删除apk采集的 通话、短信信息
    return alimsService.post('/apmAPI/evidence/deletePhoneContactRecord', params);
  },
  localHtmlDownload(params){
    return alimsService.get('/apmAPI/localHtml/downloadZip?caseId=' + params.caseId);
  },
  bcpPackbcp(params){
    return alimsService.get('/apmAPI/bcp/packbcp?caseId=' + params.caseId + '&policName='+encodeURIComponent(params.policName)+'&policNum='+encodeURIComponent(params.policNum));
  },
  bcpQuerybcp(params){
    return alimsService.get('/apmAPI/bcp/querybcp?caseId=' + params.caseId );
  },
  changePassword(params){ // 修改密码
    return alimsService.post('/apmAPI/changePassword', params);
  },
  // 根据案件id和大类，删除之前保存的证据信息
  deleteByCaseIdAndGrapType(params){
    return alimsService.post('/apmAPI/evidence/deleteByCaseIdAndGrapType?caseId='+ params.caseId + "&grapType=" + params.grapType);
  },
  delBaseInfoByCaseIdAccount(params){
    return alimsService.get('/apmAPI/evidence/delBaseInfoByCaseIdAccount?caseId=' + params.caseId + '&account='+encodeURIComponent(params.account) + "&grapType=" + params.grapType);
  },
  caseInfoDelete(caseId){
    return alimsService.get('/apmAPI/caseInfo/delete?caseId=' + caseId);
  },
  deleteByRpPersonId(rpPersonId){
    return alimsService.get('/apmAPI/caseInfo/deleteByRpPersonId?rpPersonId=' + rpPersonId);
  },
  apmAPIUpdateSysVersion(params){
    return alimsService.post('/apmAPI/updateSysVersion', params);
  },
  sysUserFindByPage(params){
    return alimsService.get('/apmAPI/sysUser/findByPage?pageNum='+params.pageNum+'&pageSize='+params.pageSize +'&account=' + encodeURIComponent(params.account) + '&userName=' + params.userName + '&organCode=' + params.organCode + '&probationStatus=' + params.probationStatus);
  },
  sysUserCreateUser(params){
    return alimsService.post('/apmAPI/sysUser/createUser', params);
  },
  sysUserUpdateUser(params){
    return alimsService.post('/apmAPI/sysUser/updateUser', params);
  },
  sysUserGetUserInfo(userId){
    return alimsService.get('/apmAPI/sysUser/getUserInfo?userId='+userId);
  },
  // 批量导入
  sysUserBathAddUser(params){
    return alimsService.post('/apmAPI/sysUser/bathAddUser', params);
  },
  // 上报地址维护
  // 新增配置
  sysUserCreateChannel(params){
    return alimsService.post('/apmAPI/sysUser/createChannel', params);
  },
  // 修改配置
  sysUserUpdateChannel(params){
    return alimsService.post('/apmAPI/sysUser/updateChannel', params);
  },
  // 配置列表(下拉)
  sysUserFindSysChannelConfig(params){
    return alimsService.get('/apmAPI/sysUser/findSysChannelConfig', params);
  },
  // 配置列表(翻页)
  sysUserFindSysChannelConfigByPage(params){
    return alimsService.get('/apmAPI/sysUser/findSysChannelConfigByPage', params);
  },

  sysConfigUpdate(params){
    return alimsService.post('/apmAPI/sysConfig/update', params);
  },
  elecEvidencePackApks(caseId){
    return alimsService.get('/apmAPI/elecEvidence/packApks?caseId='+caseId);
  },
  elecEvidenceGetApksPackage(caseId){
    return alimsService.get('/apmAPI/elecEvidence/getApksPackage?caseId='+caseId);
  },
  sysInquiryRecordQueryFirstByCaseId(caseId){
    return alimsService.get('/apmAPI/sysInquiryRecord/queryFirstByCaseId?caseId='+caseId);
  },
  sysInquiryRecordUpdateConfirmPushXk(id){
    return alimsService.get('/apmAPI/sysInquiryRecord/updateConfirmPushXk?id='+id + '&confirmPushXk=true');
  },
  /*
    -1 没有数据无需打包，0有数据但未打包完成，1打包完成可以下载
    evidencePack：为电子取证打包状态
    audioPack：为音频打包状态
  */
  elecEvidenceQueryPackStatus(caseId){
    return alimsService.get('/apmAPI/elecEvidence/queryPackStatus?caseId='+caseId);
  },
  transferdataDeletById(id){
    return alimsService.get('/apmAPI/transferdata/deletById?id='+id);
  },
  qdlogsFindByPage(params){
    return alimsService.get('/apmAPI/qdlogs/findByPage?pageNum=' + params.pageNum + '&pageSize=' + params.pageSize + '&createTimeBeg=' + params.createTimeBeg + '&createTimeEnd=' + params.createTimeEnd + '&modifyFlag=0');
  },
  qdlogsUpdateModifyFlag(id){
    return alimsService.get('/apmAPI/qdlogs/updateModifyFlag?id='+id + '&modifyFlag=0');
  },
  qdlogsUpdateDelete(id){
    return alimsService.get('/apmAPI/qdlogs/updateDelete?id='+id);
  },
  elecEvidenceDeleteByCaseIdAndPhoneIdAndJsonType(phoneId,caseId,jsonType){
    return alimsService.get('/apmAPI/elecEvidence/deleteByCaseIdAndPhoneIdAndJsonType?caseId='+caseId+'&phoneId='+phoneId+'&jsonType=' + jsonType);
  },
  // 保存安卓证据APP相关信息
  elecEvidenceSaveZjAppInfo(params){
    return alimsService.post('/apmAPI/elecEvidence/saveZjAppInfo', params);
  },
  // 保存其他证据APP相关信息
  elecEvidenceSaveOtherApp(params){
    return alimsService.post('/apmAPI/elecEvidence/saveOtherApp', params);
  },
  // 保存证据APP登录相关信息
  elecEvidenceSaveZjAppLoginInfo(params){
    return alimsService.post('/apmAPI/elecEvidence/saveZjAppLoginInfo', params);
  },
  // 保存证据APP下载相关信息
  elecEvidenceSaveZjAppDownloadInfo(params){
    return alimsService.post('/apmAPI/elecEvidence/saveZjAppDownloadInfo', params);
  },
  // 删除证据APP下载相关信息
  elecEvidenceDeleteZjAppDownloadInfo(params){
    return alimsService.get('/apmAPI/elecEvidence/deleteZjAppDownloadInfo', params);
  },
  // 删除证据APP
  elecEvidenceDelZjApp(params){
    return alimsService.get('/apmAPI/elecEvidence/delZjApp', params);
  },
  // 保存http数据包
  elecEvidenceHttpCaptureBatchSave(params){
    return alimsService.post('/apmAPI/elecEvidence/httpCaptureBatchSave', params);
  },
  // 动态分析列表查询
  elecEvidenceQueryAppHttpCapture(params){
    return alimsService.get('/apmAPI/elecEvidence/queryAppHttpCapture', params);
  },
  // 删除动态分析
  elecEvidenceDeleteHttpCaptureById(params){
    return alimsService.get('/apmAPI/elecEvidence/deleteHttpCaptureById', params);
  },
  // 静态分析
  // 查询（状态2标识解析中）
  elecEvidenceQueryStaticAnalyseById(params){
    return alimsService.get('/apmAPI/elecEvidence/queryStaticAnalyseById', params);
  },
  // 重试
  elecEvidenceRetryStaticAnalyseApk(params){
    return alimsService.get('/apmAPI/elecEvidence/retryStaticAnalyseApk', params);
  },
  // 保存静态分析
  elecEvidenceSaveStaticAnalyseApk(params){
    return alimsService.post('/apmAPI/elecEvidence/saveStaticAnalyseApk', params);
  },
  // 删除静态分析
  elecEvidenceDeleteStaticAnalyseApk(params){
    return alimsService.get('/apmAPI/elecEvidence/deleteStaticAnalyseApk', params);
  },
  // 获取签名信息
  elecEvidenceQueryZjAppById(params){
    return alimsService.get('/apmAPI/elecEvidence/queryZjAppById', params);
  },
  // 重新分析签名信息
  elecEvidenceRetryAnalyseApk(params){
    return alimsService.get('/apmAPI/elecEvidence/retryAnalyseApk', params);
  },
  elecEvidenceReadQRCode(filePath){
    return alimsService.post('/apmAPI/elecEvidence/readQRCode',{'filePath':filePath});
  },
  // 保存涉诈app图片信息
  elecEvidenceSaveAppEnclosureInfo(params){
    return alimsService.post('/apmAPI/elecEvidence/saveAppEnclosureInfo', params);
  },
  evidenceUpdateBaseInfo(params){
    return alimsService.post('/apmAPI/evidence/updateBaseInfo', params);
  },
  evidenceUpdateBaseInfoList(params){
    return alimsService.post('/apmAPI/evidence/updateBaseInfoList', params);
  },

  // 统计管理 Start
  // 案件采集情况
  queryCaseStatistics(params){
    return alimsService.get('/apmStatistics/statistics/queryCaseStatistics', params);
  },
  // 事主采集情况
  queryReportPersonStatistics(params){
    return alimsService.get('/apmStatistics/statistics/queryReportPersonStatistics', params);
  },
  queryReportPersonStatisticsExcel(params){
    return alimsService.get('/apmStatistics/statistics/queryReportPersonStatisticsExcel', params);
  },



  // 询问人排名情况
  queryPersonRankStatistics(params){
    return alimsService.get('/apmStatistics/statistics/queryPersonRankStatistics', params);
  },
  // 单位排名情况
  queryOrganizationRankStatistics(params){
    return alimsService.get('/apmStatistics/statistics/queryOrganizationRankStatistics', params);
  },
  reportPersonGenerateBlDoc(personId){
    return alimsService.get('/apmAPI/reportPerson/generateBlDoc?personId=' + personId);
  },
  reportPersonGenerateSzDoc(personId){
    return alimsService.get('/apmAPI/reportPerson/generateSzDoc?personId=' + personId);
  },
  tempFileDataSaveList(params){
    return alimsService.post('/apmAPI/tempFileData/saveList', params);
  },
  tempFileDataQueryByQrId(qrId){
    return alimsService.get('/apmAPI/tempFileData/queryByQrId?qrId='+ qrId);
  },
  tempFileDataDeletByQrId(qrId){
    return alimsService.get('/apmAPI/tempFileData/deletByQrId?qrId='+ qrId);
  },
  apkPackApkZip(params){
    return alimsService.post('/apmAnalyse/apk/packApkZip?caseId=' + params.caseId);
  },
  queryApkZipStatus(caseId){
    return alimsService.get('/apmAnalyse/apk/queryApkZipStatus?caseId='+ caseId);
  },
  downloadApkZip(caseId){
    return alimsService.get('/apmAnalyse/apk/downloadApkZip?caseId='+ caseId);
  },

  // 缓存重构
  dataExtractionetCaseInfoByIdG(caseId){
    return alimsService.get('/apmAPI/caseInfo/getCaseInfoById?id='+ caseId);
  },
  dataExtractionGetPhoneInfoByCaseId(caseId){
    return alimsService.get('/apmAPI/evidence/getPhoneInfoByCaseId?caseId='+ caseId);
  },
  evidenceGetZjBaseInfoByCaseId(caseId){
    return alimsService.get('/apmAPI/evidence/getZjBaseInfoByCaseId?caseId='+ caseId);
  },
  elecEvidenceQueryCaseAppByCaseId(caseId){
    return alimsService.get('/apmAPI/elecEvidence/queryCaseAppByCaseId?caseId='+ caseId);
  },
  // 获取当前案件所有电子取证信息包含是否完成状态
  elecEvidenceGetDzMapByCaseId(caseId){
    return alimsService.get('/apmAPI/elecEvidence/getDzMapByCaseId?caseId='+ caseId);
  },
  blTemplateFindByPage(){
    return alimsService.get('/apmAPI/blTemplate/findByPage?pageNum=1&pageSize=9999999');
  },
  blTemplateSave(params){
    return alimsService.post('/apmAPI/blTemplate/save', params);
  },
  blTemplateBatchUpdate(params){
    return alimsService.post('/apmAPI/blTemplate/batchUpdate', params);
  },
  blTemplateDeleteByIds(ids){
    return alimsService.get('/apmAPI/blTemplate/deleteByIds?'+ ids);
  },
  resetPassword(userid){
    return alimsService.get('/apmAPI/resetPassword?userId='+ userid);
  },
  evidenceTransZjFile(caseId){
    return alimsService.get('/apmAPI/evidence/transZjFile?caseId='+ caseId);
  },
  evidenceDeleteTelContactsAudio(caseId,account,phoneId){
    return alimsService.get('apmAPI/evidence/deleteTelContactsAudio?caseId='+caseId+'&account='+account+'&phoneId=' + phoneId);
  },
  sysConfigUpdateQdVersion(params){
    return alimsService.post('/apmAPI/sysConfig/updateQdVersion', params);
  },
  sysConfigQueryQdVersion(){
    return alimsService.get('/apmAPI/sysConfig/queryQdVersion?configKey=10');
  },
  getUploadFlag0LList(params){
    return alimsService.get('/apmAPI/elecEvidence/getUploadFlag0LList' + (params.ryName ? '?ryName=' + encodeURIComponent(params.ryName) : ''));
  },
  updateDzMd5FileUploadFlag(caseId,smallType,phoneId){
    return alimsService.get('/apmAPI/elecEvidence/updateDzMd5FileUploadFlag?caseId=' + caseId + '&smallType=' + smallType + '&phoneId=' + phoneId);
  },
  updateCaseReportStatusTo4(caseId){
    return alimsService.get('/apmAPI/caseInfo/updateCaseReportStatusTo4?caseId=' + caseId);
  },
  updateCaseReportStatusTo5(caseId){
    return alimsService.get('/apmAPI/caseInfo/updateCaseReportStatusTo5?caseId=' + caseId);
  },
  /**
   * @description 通知通告接口
   * */
  // 保存通知通告
  sysNoticeSave(params){
    return alimsService.post('/apmAPI/sysNotice/save', params);
  },
  // 更新通知通告
  sysNoticeUpdate(params){
    return alimsService.post('/apmAPI/sysNotice/update', params);
  },
  // 删除通知通告
  sysNoticeDeleteById(params){
    return alimsService.get('/apmAPI/sysNotice/deleteById', params);
  },
  // 通知通告分页列表
  sysNoticeFindByPage(params){
    return alimsService.get('/apmAPI/sysNotice/findByPage', params);
  },
  // 获取有效期内的通知通告列表
  sysNoticeFindExpiryNotice(params){
    return alimsService.get('/apmAPI/sysNotice/findExpiryNotice', params);
  },

  // 设备编号操作
  // 根据客户端服务编号
  sysDeviceCodesGetByDeviceCode(params){
    return alimsService.get('/apmAPI/sysDeviceCodes/getByDeviceCode', params);
  },
  // 更新保存服务编号
  sysDeviceCodesInsertOrUpdate(params){
    return alimsService.post('/apmAPI/sysDeviceCodes/insertOrUpdate', params);
  },
}

export default registeAPI



// WEBPACK FOOTER //
// ./src/api/registe.service.js